module.exports = __webpack_public_path__ + "static/media/sistema-historico-plano-elite.6ba118e2.png";